import React from 'react';
import { Box, Skeleton, Stack } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackPatientInfoLoader() {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      height: '60px',
      alignItems: 'flex-end',
      gap: 3,
      px: 3
    },
    children: [/*#__PURE__*/_jsx(Skeleton, {
      sx: {
        height: '56px',
        width: '56px',
        transform: 'none',
        borderRadius: '50%',
        flexShrink: 0
      }
    }), /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          height: '35px',
          width: '220px'
        }
      }), /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 1,
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          sx: {
            height: '28px',
            width: '120px'
          }
        }), /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            height: '28px',
            width: '200px',
            marginLeft: 4
          }
        })]
      })]
    })]
  });
}